import React from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

const Tooltip = ({ content }) => {
  return (
    content ? (
      <Tippy content={content}>
        <button type='button' aria-label='tooltip' className='tooltip-button'>
          <svg
            fill='none'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fill='#000'
              clipRule='evenodd'
              fillRule='evenodd'
              d='M22 12c0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10C2 6.47715 6.47715 2 12 2c5.5228 0 10 4.47715 10 10zm-9-4c0 .55228-.4477 1-1 1s-1-.44772-1-1 .4477-1 1-1 1 .44772 1 1zm-1 2c-.5523 0-1 .4477-1 1v5c0 .5523.4477 1 1 1s1-.4477 1-1v-5c0-.5523-.4477-1-1-1z'
            />
          </svg>
        </button>
      </Tippy>
    ) : null
  )
}

export default Tooltip
